import { COUNTRIES } from "@/data/countries";

// Build a lookup map from country name to ISO code (lowercase)
const countryNameToCode: Record<string, string> = {};
COUNTRIES.forEach((c) => {
  // Normalize code: "GB-SCT" -> "gb", "FR-COR" -> "fr", etc.
  const code = c.code.includes("-") ? c.code.split("-")[0].toLowerCase() : c.code.toLowerCase();
  countryNameToCode[c.name] = code;
});

/**
 * Returns a flagcdn.com image URL for a given country name.
 * Returns null if the country is not found.
 */
export const getFlagUrl = (countryName: string): string | null => {
  const code = countryNameToCode[countryName];
  return code ? `https://flagcdn.com/${code}.svg` : null;
};
